import { HttpResponseErrorId, HttpResponseType } from '../model/AppUIShapes';

export default function isArraiesEqualByGUID(arraySource: any[] | undefined, arrayTarget: any[] | undefined) {
  if (!arraySource && !arrayTarget) return true;
  if (!arraySource) return false;
  if (!arrayTarget) return false;

  if (arraySource.length != arrayTarget.length) return false;

  let matchedCount = 0;
  arraySource.forEach((itemSource) => {
    const targets = arrayTarget.filter((itemTarget) => itemTarget.guid === itemSource.guid);
    if (targets && targets.length > 0) {
      matchedCount++;
    }
  });
  return matchedCount === arrayTarget.length;
}

export const fetchHttpResponseHandler = async (response: any) => {
  if (response.status === 404 || response.status === 403 || response.status === 401 || response.status >= 500) return fetchErrorHandler(response.status);
  else {
    // 直接解析JSON并返回处理后的响应
    const content = await response.json();
    return {
      responseType: HttpResponseType.SUCCESS,
      message: '',
      content: content
    };
  }
};

const fetchErrorHandler = (httpStatus: number) => {
  let responseType = HttpResponseType.ERROR;
  switch (httpStatus) {
    case 401:
    case 403:
      responseType = HttpResponseType.NO_AUTH;
      break;
    case 404:
      responseType = HttpResponseType.UNKNOWN;
      break;
    default:
      break;
  }
  return {
    responseType: responseType,
    message: HttpResponseErrorId.EXCEPTION,
    content: undefined
  };
};

export const fetchHttpExceptionHandler = () => {
  return {
    responseType: HttpResponseType.ERROR,
    message: HttpResponseErrorId.EXCEPTION,
    content: undefined
  };
};
